/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MaintenanceRequest = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        companyId: {
    type: 'string',
    isRequired: true,
},
        details: {
    type: 'string',
    isRequired: true,
},
        assignee: {
    type: 'number',
    isNullable: true,
},
        status: {
    type: 'number',
    isRequired: true,
},
        deadline: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
        location: {
    type: 'string',
    isNullable: true,
},
        completionComment: {
    type: 'string',
    isNullable: true,
},
        completedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
    },
};